import type { Map as LeafletMap } from 'leaflet';
import type { RefObject } from 'react';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

type Props = {
  mapRef: RefObject<LeafletMap | null>;
};

export const MapInstanceCapture = ({ mapRef }: Props) => {
  const map = useMap();

  useEffect(() => {
    mapRef.current = map;
    return () => {
      mapRef.current = null;
    };
  }, [map, mapRef]);

  return null;
};
